import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        // Handle newsletter subscription
    };

    return (
        <footer className="footer">
            <div className="footer-wave">
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M0,0 C300,80 600,80 900,40 L1200,20 L1200,120 L0,120 Z" fill="#F59E0B" opacity="1"></path>
                </svg>
            </div>
            <div className="footer-wave-white">
                <svg viewBox="0 0 1200 60" preserveAspectRatio="none">
                    <path d="M0,20 C300,60 600,60 900,30 L1200,15 L1200,60 L0,60 Z" fill="#ffffff" opacity="1"></path>
                </svg>
            </div>
            <div className="container">
                <div className="footer-content">
                    <div className="footer-col">
                        <div className="footer-logo">
                            <img src="/NIDLOGO.jpeg" alt="Logo" className="footer-logo-img" />
                            <span>Nidharsanam Public Charitable Trust</span>
                        </div>
                        <p>Making a positive impact on communities worldwide through sustainable development and compassionate action.</p>
                    </div>
                    
                    <div className="footer-col">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/programs">Our Programs</Link></li>
                            <li><Link to="/gallery">Gallery</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                    
                    <div className="footer-col">
                        <h4>Get Involved</h4>
                        <ul>
                            <li><Link to="/volunteer">Volunteer</Link></li>
                            <li><Link to="/partner">Partner With Us</Link></li>
                            <li><Link to="/careers">Careers</Link></li>
                        </ul>
                    </div>
                    
                    <div className="footer-col">
                        <h4>Newsletter</h4>
                        <p>Stay updated with our latest news and events</p>
                        <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                            <input type="email" placeholder="Your email" required />
                            <button type="submit"><i className="fas fa-paper-plane"></i></button>
                        </form>
                    </div>
                </div>
                
                <div className="footer-bottom">
                    <p>&copy; 2026 Nidharsanam Public Charitable Trust. All rights reserved. | <Link to="/privacy">Privacy Policy</Link> | <Link to="/terms">Terms of Service</Link></p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
